<div class='head'>
    <div class='container'>
        <h1 class='contact'>
            Contacts
        </h1>
        <p>
            <span class='subtitle'>WE ARE HERE TO HELP YOU</span>
        </p>
    </div>
</div>
<br /><br />

<div class='container'>
    <div class='row'>
        <div class='col-md-6 col-12'>
            <p class='title'>
                Need Help With Your Order?
            </p>
            <h4><b>012 - 23423 345345</b></h4>
            <hr />
            <p class='title'>
                Send Us a Message
            </p>
            <sub style='font-size: medium;'>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
            </sub>
            <br /><br />
            <mat-form-field appearance="outline">
                <mat-label>Name</mat-label>
                <input matInput placeholder="">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput placeholder="">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Phone Number</mat-label>
                <input matInput placeholder="">
            </mat-form-field>    
    
            <mat-form-field appearance="outline">
                <mat-label>Subject</mat-label>
                <input matInput placeholder="">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Message</mat-label>
                <textarea matInput placeholder=""></textarea>
                <!-- <input > -->
            </mat-form-field>
            <button mat-button class='create_submit'>Submit</button>
            <br />
            <br />
        </div>

        <div class='col-md-6 col-12'>
            <mat-card>
                <br />
                <mat-card-title>Headquater</mat-card-title>
                <p class='address'>
                    Building No. - 120,<br />
                    New Friends Colony,<br />
                    Sanjay Nagar,<br />
                    Ghaziabad - 201002
                </p>
                <div>
                    <iframe width="100%" height="450" id="gmap_canvas" 
                    src="https://maps.google.com/maps?q=India&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0">
                    </iframe>
                </div>
            </mat-card>
        </div>
    </div>
    <br />
    <br />
</div>